import React, { useState } from 'react';
import './EventosDestacadosWidget.css';
import { Link, Route } from 'react-router-dom';

const EventosDestacadosWidget = () => {
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className={`eventos-widget ${expanded ? 'expanded' : ''}`}>
      <div className="eventos-widget__header">
        <button
          className="eventos-widget__button"
          onClick={() => setExpanded(!expanded)}
        >
          🎉 Eventos destacados
        </button>
        <button
          className="eventos-widget__close"
          onClick={() => setVisible(false)}
          aria-label="Cerrar"
        >
          ✕
        </button>
      </div>

      {expanded && (<Link to="https://laofieventos.odoo.com/event" target="_blank" >
        <div className="eventos-widget__iframe-container">
          <iframe
            src="https://laofieventos.odoo.com/event"
            title="Eventos LaOfi"
            width="100%"
            height="100%"
            frameBorder="0"
          ></iframe>
        </div></Link>
      )}
    </div>
  );
};

export default EventosDestacadosWidget;
